module.exports = __webpack_public_path__ + "media/images/flags/16/Seychelles-bcdc7ea064df45788b544b33ffca03bd.png";